import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';

interface SpinnerState {
  activeRequests: number;
  isLoading: boolean;
}

const initialState: SpinnerState = {
  activeRequests: 0,
  isLoading: false,
};

export const SpinnerStore = signalStore(
  { providedIn: 'root' },
  withState<SpinnerState>(initialState),
  withMethods((store) => ({
    incrementActiveRequests() {
      patchState(store, (state) => ({
        activeRequests: state.activeRequests + 1,
        isLoading: true, // Spinner is active when there are active requests
      }));
    },
    decrementActiveRequests() {
      patchState(store, (state) => {
        const activeRequests = Math.max(state.activeRequests - 1, 0);
        return {
          activeRequests,
          isLoading: activeRequests > 0, // Spinner stops only when no active requests remain
        };
      });
    },
    reset() {
      patchState(store, initialState);
    },
  }))
);